// 新聞摘要（AI + 原始）
'use client';
import { useEffect, useState } from 'react';
import AnimatedBorderTrail from '../animation/AnimatedBorderTrail'; // 動畫邊框
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import exchangeClient from '@/common/apiClient/exchangeClient';

const NewsBrief = ({ brief, briefAi, slug }) => {
    const { t } = useTranslation();
    const [showBrief, setShowBrief] = useState(false); // 顯示摘要
    const [isExecute, setIsExecute] = useState(false); // 是否執行

    // 執行點擊 ai 摘要任務
    const executeTask = async () => {
        setShowBrief((prev) => !prev);

        if (!isExecute) {
            try {
                setIsExecute(true);
                const result = await exchangeClient.executeTask(slug);
            } catch (e) {
                console.error(e);
            }
        }
    };

    return (
        <>
            {/* 原始摘要 */}
            <p className="text-bd2n text-black font-[300] break-words">{brief}</p>

            {/* AI 摘要 有資料顯示 */}
            {briefAi && (
                <AnimatedBorderTrail className="w-full">
                    <div
                        className={`ai-summary w-full overflow-hidden ${
                            showBrief ? 'max-h-[3000px]' : 'max-h-[48px]'
                        }`}
                    >
                        <div
                            className="between-center cp text-btn1 text-black9 group px-[20px] py-[12px]"
                            onClick={executeTask}
                        >
                            <div className="flex items-center gap-x-[14px]">
                                <div className="img-box w-[24px] h-[24px] after:content-none trans group-hover:translate-x-[5px]">
                                    <Image
                                        className="brightness-[30%] dark:brightness-[unset]"
                                        width={24}
                                        height={24}
                                        src="/images/icon/icon_brief.svg"
                                        alt="icon"
                                    />
                                </div>
                                <span className="trans group-hover:translate-x-[5px]">
                                    {t('AI_BRIEF')}
                                </span>
                            </div>
                            <span className="trans group-hover:translate-x-[-5px]">
                                <span
                                    className={`inline-block ${showBrief ? 'rotate-[45deg]' : ''}`}
                                >
                                    ＋
                                </span>{' '}
                                {showBrief ? '收起' : t('READ')}
                            </span>
                        </div>

                        {showBrief && (
                            <pre className="px-[60px] mt-[30px] pb-[20px] mb-[20px] text-bd1m text-black9 umd:px-[25px] whitespace-pre-wrap">
                                {briefAi}
                            </pre>
                        )}
                    </div>
                </AnimatedBorderTrail>
            )}
        </>
    );
};

export default NewsBrief;
